
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      stats: [],
    };
  },
  computed: {
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
    seasonId () {
      return this.fixture.stage.seasonId;
    },
    statsConfig () {
      return this.additionalConfig?.match_centre_config?.sidebar_stats_groups;
    },
  },
};
